var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLocked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_permissions24x24",
    d: "M75.445,6.278V5a5,5,0,0,0-10,0V6.278a1.993,1.993,0,0,0-1,1.722v6a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V8a1.993,1.993,0,0,0-1-1.722ZM70.445,2a3,3,0,0,1,3,3V6h-6V5A3,3,0,0,1,70.445,2Zm1,9.611V13h-2V11.611a1.5,1.5,0,1,1,2,0Z",
    transform: "translate(-64.445)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_locked.1b8a5555b84e16a2372430e86ebe643a.svg";